import {sharedDataTemplate} from './dataTemplate';

const Projects = sharedDataTemplate('projects');

export default Projects;
